export default "/assets/website/images/2022.jpeg?e8577ae6b0cb4943336113801f225c35";